import { Form, Input, Card, Typography, Space } from "antd"
import { SafetyOutlined, EditOutlined } from "@ant-design/icons"
import { toastError, toastSuccess } from "../../utils/toast"
import ButtonBack from "../../components/button/ButtonBack"
import ButtonSubmitBack from "../../components/button/ButtonSubmitBack"
import { useLoading } from "../../context/LoadingContext"
import { apiUpdateRole } from "../../api"
import { convertListStringToPermission } from "../../utils/perm-utils"
import { ListFormCheckbox } from "./FormCheckbox"
import { permissionOptions } from "../../assets/constants/default_options"
import { IFormValueRole, IRole } from "../../models/role.model"
import { useLocation, useNavigate } from "react-router-dom"
import { useEffect } from "react"
import { ADMIN, ROLE } from "../../assets/constants/route_path"

const { Title } = Typography

export default function RoleUpdate() {
    const [formUpdate] = Form.useForm()
    const { setIsLoading } = useLoading()
    const location = useLocation()
    const navigate = useNavigate()
    const role = location.state as IRole

    useEffect(() => {
        if (!role) {
            navigate(role)
        }
    }, [role, navigate])

    const handleUpdate = async ({ name, description, ...groups }: IFormValueRole) => {
        try {
            setIsLoading(true)
            const perms = Object
                .entries(groups)
                .map(([_, value]) => convertListStringToPermission(value))
                .flat(Infinity) as []
            const resp = await apiUpdateRole({
                id: Number(role.id),
                name,
                description,
                permissions: perms,
            })
            if (resp.status === 200) {
                toastSuccess('Cập nhật phân quyền thành công!')
                formUpdate.resetFields()
                navigate(ADMIN + ROLE)
            } else {
                toastError('Có lỗi xảy ra!')
            }
            setIsLoading(false)
        } catch (error) {
            console.log(error);
            toastError('Có lỗi xảy ra!')
            setIsLoading(false)
        }
    }

    return (
        <div>
            <ButtonBack />
            <Card
                style={{
                    borderRadius: '16px',
                    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
                    background: 'linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)',
                    border: 'none',
                    overflow: 'hidden'
                }}
            >
                <div style={{
                    padding: '20px 0',
                }}>
                    <Title level={3} style={{
                        margin: 0,
                        color: '#1a1a1a',
                        fontWeight: '600'
                    }}>
                        <EditOutlined style={{ marginRight: '12px', color: '#722ed1' }} />
                        Cập nhật phân quyền
                    </Title>
                    <p style={{
                        marginTop: 8,
                        color: '#666',
                    }}>
                        Cập nhật quyền hạn và phân quyền cho người dùng
                    </p>
                </div>
                <Form form={formUpdate} onFinish={handleUpdate} layout="vertical">
                    <Card
                        style={{
                            marginBottom: '24px',
                            borderRadius: '12px',
                            border: '1px solid #e2e8f0',
                            background: 'linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)'
                        }}
                        title={
                            <Space>
                                <EditOutlined style={{ color: '#667eea' }} />
                                <span style={{ color: '#2d3748', fontWeight: 600 }}>Thông tin cơ bản</span>
                            </Space>
                        }
                    >
                        <Form.Item
                            initialValue={role.name}
                            name='name'
                            label={
                                <span style={{ color: '#2d3748', fontWeight: 500 }}>
                                    Tên phân quyền
                                </span>
                            }
                            rules={[{ required: true, message: 'Vui lòng nhập tên phân quyền!' }]}
                        >
                            <Input
                                size="large"
                                placeholder="Nhập tên phân quyền..."
                                style={{
                                    borderRadius: '8px',
                                    border: '2px solid #e2e8f0',
                                    transition: 'all 0.3s ease'
                                }}
                            />
                        </Form.Item>
                        <Form.Item
                            initialValue={role.description}
                            name='description'
                            label={
                                <span style={{ color: '#2d3748', fontWeight: 500 }}>
                                    Mô tả
                                </span>
                            }
                        >
                            <Input
                                size="large"
                                placeholder="Nhập mô tả phân quyền..."
                                style={{
                                    borderRadius: '8px',
                                    border: '2px solid #e2e8f0',
                                    transition: 'all 0.3s ease'
                                }}
                            />
                        </Form.Item>
                    </Card>
                    <Card
                        style={{
                            marginBottom: '24px',
                            borderRadius: '12px',
                            border: '1px solid #e2e8f0',
                            background: 'linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)'
                        }}
                        title={
                            <Space>
                                <SafetyOutlined style={{ color: '#667eea' }} />
                                <span style={{ color: '#2d3748', fontWeight: 600 }}>Phân quyền chi tiết</span>
                            </Space>
                        }
                    >
                        <ListFormCheckbox options={permissionOptions} initValues={role.permissions} />
                    </Card>
                    <ButtonSubmitBack />
                </Form>
            </Card>
        </div>
    )
}
